<template>
    <div :class="['hpBoxchild']" :id="`hpBox${index}`">
        <div class="img">
          <div class="boxBg"></div>
            <!-- 
            <div class="maskedImg">
                <div :class="['hpBoxBgMask',getDealyClass]">
                    <div :class="['bg',getDealyClass]" v-bind:style="{ width: midBoxesW + 'px' }"></div>
                </div>
            </div>
            -->
        </div>
        <div class="t1 split-text">Blog element title</div>
        <div class="t2 split-text">Descriptio of the element</div>
    </div>
</template>

<style>

    .boxBg
    {    
        width: 100%;
        height: 100%;
        background-position: center center;
        background-size: cover;        
    }


  .hpBoxchild .t1{
    padding-top: 10px;
    font-size: 25px;color: #2a2a2a;letter-spacing: -1px !important;
    line-height: 30px;
    font-weight: 400 !important;
  }
  .hpBoxchild .t2{
    font-size: 14px; color: #333;
  }
/* 
  .maskedImg{
    background: transparent;
    height: 60vh;
    width: 100%;
    z-index: 110;
    overflow: hidden;
    position: absolute;
  }
  .maskedImg .hpBoxBgMask {
      width: 0px;
      height: 100%;
      position: relative;
      overflow: hidden;
  }
  .maskedImg .hpBoxBgMask .bg {
      background-size: cover;
      background-position: center center;
      width: 414px;
      height: 100%;
      background-image: url('https://vumbnail.com/228635702.jpg');
  } */

  /* 3 boxes animations */
  /* .maskedImg .hpBoxBgMask {
      -webkit-transition: all 1500ms cubic-bezier(0.645, 0.045, 0.355, 1.000);
      -moz-transition: all 1500ms cubic-bezier(0.645, 0.045, 0.355, 1.000);
      -o-transition: all 1500ms cubic-bezier(0.645, 0.045, 0.355, 1.000);
      transition: all 1500ms cubic-bezier(0.645, 0.045, 0.355, 1.000); 
  }
  .rowBanner
  {
    background: #074a6f;
    height: 60vh;
    width: 100%;
    background-size: cover;
    background-position: center center;
    background-image: url('https://vumbnail.com/228635702.jpg');
  }

  .bg
  {
    transform: scale(1.1);
    transition: all 2s cubic-bezier(0.645, 0.045, 0.355, 1.000); 
  }
  .maskOpen .bg
  {
    transform: scale(1);
  } */

</style>


<script>
import { mapActions, mapState } from "vuex";
export default {
    props: ["index","delayClass","midBoxesW"],
  name: "hpBox",
  data() {
    return {
      someprop: false,
    };
  },
  watch: {

  },
  created() {

  },
  destroyed() {

  },
  methods: {
    ...mapActions(["initRouteByPath", "setPageReady", "dirtifyHome"]),
  },
  computed: {
      getDealyClass(){
          return this.delayClass;
      }
  }
};
</script>

